import { useState } from "react";
import Form from "../../ui/Form.jsx";
import { useLogin } from "./useLogin";
import FormRowVertical from "../../ui/FormRowVertical.jsx";
import Input from "../../ui/Input.jsx";
import Button from "../../ui/Button.jsx";
import SpinnerMini from "../../ui/SpinnerMini.jsx";

function LoginForm() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { login, isLoading } = useLogin();

    function handleSubmit(e) {
        e.preventDefault();
        if (!email || !password) return;
        login(
            { email, password },
            {
                onSettled: () => {
                    setEmail("");
                    setPassword("");
                },
            }
        );
    }

    return (
        <Form onSubmit={handleSubmit}>
            <FormRowVertical label="Email address">
                <Input className="" 
                    type="email"
                    id="email"
                    // This makes this form better for password managers
                    autoComplete="username"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                />
            </FormRowVertical>

            <FormRowVertical label="Password">
                <Input className=""
                       type="password"
                    id="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                />
            </FormRowVertical>
            <FormRowVertical>
                <Button size="small" disabled={isLoading}>
                    {!isLoading ? "Log in" : <SpinnerMini/>}
                </Button>
                <div className={"flex mt-4 justify-center"}>
                    
                {/*<p className="text-sm text-gray-600 align-center mt-2">*/}
                {/*    Don't have an account?{' '}*/}
                {/*    <a*/}
                {/*        href="/register"*/}
                {/*        className="text-blue-600 hover:underline"*/}
                {/*    >*/}
                {/*        Sign Up*/}
                {/*    </a>*/}
                {/*</p>*/}
                </div>
            </FormRowVertical>
        </Form>
    );
}

export default LoginForm;
